import React from "react";
import Header from "../../Components/Header";
import "./index.css";
import RewardsHeader from "../../Components/Rewards/RewardsHeader/RewardsHeader";
import GetRewarded from "../../Components/Rewards/GetRewarded/GetRewarded";
import KeepControl from "../../Components/Rewards/KeepControl/KeepControl";
import Footer from "../../Components/Footer";
import { Col, Container, Row } from "react-bootstrap";
import imgform from "../../assets/Frame8674.webp";
import JoinWaitListForm from "../../Components/Rewards/JoinWaitList/JoinWaitListForm";
import { useSelector } from "react-redux";

const RewardsPage = () => {
  const user = JSON.parse(useSelector((state) => state.user.user));
  return (
    <>
      <Header />
      <RewardsHeader />
      <GetRewarded />
      <KeepControl />
      {!user && (
        <Container fluid className="px-0 custom-black pt-4 pb-4" id="join">
          <Container>
            <div className="bg_form_g">
              <Row className="py-3 align-items-center">
                <Col lg={7}>
                  {" "}
                  <img src={imgform} alt="logo" className="img-fluid" />
                </Col>
                <JoinWaitListForm />
              </Row>
            </div>
          </Container>
        </Container>
      )}

      <Footer />
    </>
  );
};

export default RewardsPage;
